import React, {createContext, useContext, useState, ReactNode} from 'react';

// Define the shape of the context data
interface MyContextType {
  onlineData: any;
  setOnlineData: (value: any) => void;
  questionsData:any;
  setQuestionData: (value: any) => void;
  uiFields: any;
  setUiFields: (value: any) => void;
  dropDowndata: any;
  setDropDownData: (value: any) => void;
  screenLoader: boolean;
  setScreenLoader: (value: boolean) => void;
  optionsRendered: boolean;
  setOptionsRendered: (value: boolean) => void;
  optionsRenderedQuestion: boolean;
  setOptionsRenderedQuestion: (value: boolean) => void;
  screenSave: boolean;
  setScreenSave: (value: boolean) => void;
  screenSaveBack: boolean;
  setScreenSaveBack: (value: boolean) => void;
  questionLoader: boolean;
  setQuestionLoader: (value: boolean) => void;
}

// Create the context with default values
const OnlineContext = createContext<MyContextType | undefined>(undefined);

// Create a provider component
export const OnlineContextProvider: React.FC<{children: ReactNode}> = ({
  children
}) => {
  const [onlineData, setOnlineData] = useState();
  const [questionsData,setQuestionData]=useState<any[]>([])
  const [uiFields, setUiFields] = useState();
  const [dropDowndata, setDropDownData] = useState<any[]>([]);
  const [screenLoader, setScreenLoader] = useState(false);
  const [questionLoader,setQuestionLoader]=useState(false)
  const [optionsRendered, setOptionsRendered] = useState(false);
  const [optionsRenderedQuestion, setOptionsRenderedQuestion] = useState(false);
  const [screenSave, setScreenSave] = useState(false);
  const [screenSaveBack, setScreenSaveBack] = useState(false);
  return (
    <OnlineContext.Provider
      value={{
        onlineData,
        setOnlineData,
        questionsData,
        setQuestionData,
        uiFields,
        setUiFields,
        dropDowndata,
        setDropDownData,
        screenLoader,
        setScreenLoader,
        optionsRendered,
        setOptionsRendered,
        optionsRenderedQuestion,
        setOptionsRenderedQuestion,
        screenSave,
        setScreenSave,
        screenSaveBack,
        setScreenSaveBack,
        questionLoader,
        setQuestionLoader
      }}>
      {children}
    </OnlineContext.Provider>
  );
};

// Custom hook to use the context
export const useOnlineContext = () => {
  const context = useContext(OnlineContext);
  if (context === undefined) {
    throw new Error(
      'useOnlineContext must be used within an OnlineContextProvider'
    );
  }
  return context;
};
